import React from "react";
import AssetLocationUpdate from './RequestTypes/AssetLocationUpdate';
import EndOfLease from './RequestTypes/EndOfLease';
import RequestPayoff from './RequestTypes/RequestPayoff';
import SerialNumberUpdate from './RequestTypes/SerialNumberUpdate';

interface RequestType {
    value: string;
    label: string;
    component?: React.FC<any>;
}

const assetRequestTypes: RequestType[] = [
    { value: 'generalSupport', label: 'General Support' },
    { value: 'assetLocationUpdate', label: 'Asset Location Update', component: AssetLocationUpdate },
    { value: 'endOfLease', label: 'End of Lease', component: EndOfLease },
    { value: 'requestPayoff', label: 'Request Payoff', component: RequestPayoff },
    { value: 'serialNumberUpdate', label: 'Serial Number Update', component: SerialNumberUpdate },
];

const contractRequestTypes: RequestType[] = [
    { value: 'generalSupport', label: 'General Support' }
];

const invoiceSupportRequestType: RequestType[] = [
    { value: 'generalSupport', label: 'General Support' }
];

export { assetRequestTypes, contractRequestTypes, invoiceSupportRequestType };
export type { RequestType };
